<template>
  <CollapsibleComponent
    class="profile-component"
    multiple
    :slots="localModelComputed.map((value) => value.slotTitle)">

    <template v-for="(slot, index) in localModelComputed" v-slot:[slot.buttonSlot]>
      <EditButton v-model="slot.editor.edit" :key="slot.buttonSlot" @save="onSave(index)"
                  @discard="onDiscard(index)"/>
    </template>

    <template v-for="(slot, index) in localModelComputed" v-slot:[slot.contentSlot]>
      <AvatarEditorComponent v-if="typeof slot.avatar !== 'undefined'" :key="slot.contentSlot + 'avatarEditorComponent'"
                             v-bind="slot.avatar"
                             :edit="slot.editor.edit"
                             @avatarFileSelected="(file) => onAvatarFileSelected(file, localModel[index])"/>
      <FieldViewCard :key="slot.contentSlot + 'fieldViewCard'" v-if="!slot.editor.edit" :fields="slot.fields"/>
      <EditorCardComponent :editable="false" :key="slot.contentSlot + 'editorCardComponent'" v-if="slot.editor.edit"
                           v-model="slot.fields"/>
    </template>

  </CollapsibleComponent>
</template>

<script>
import CollapsibleComponent from "@/components/profile/CollapsibleComponent";
import EditButton from "@/components/buttons/EditButton";
import {toRefs, ref, watch, computed} from "@vue/composition-api";
import FieldViewCard from "@/components/form/FieldViewCard";
import EditorCardComponent from "@/components/form/EditorCardComponent";
import AvatarEditorComponent from "@/components/form/AvatarEditorComponent";

export default {
  name: "ProfileComponent",
  components: {AvatarEditorComponent, EditorCardComponent, FieldViewCard, EditButton, CollapsibleComponent},
  props: {
    value: Array
  },
  setup(props, {emit}) {

    const localModel = ref([])

    function resetLocalModel() {
      localModel.value = []
      props.value.forEach((slot) => {
        let newSlot = {...slot}
        newSlot.fields = slot.fields.map(field => Object.assign({}, field))
        if (slot.avatar) newSlot.avatar = Object.assign({}, slot.avatar)
        localModel.value.push(newSlot)
      })
    }

    resetLocalModel()
    props.value.forEach((slot) => {
      const slotRefs = Object.values(toRefs(slot))
      const fieldRefs = slot.fields.reduce((acc, cur) => {
        return [...acc, ...Object.values(toRefs(cur))]
      }, [])
      watch([...slotRefs, ...fieldRefs, () => slot, () => props.value], () => {
        resetLocalModel()
      })
    })

    const localModelComputed = computed(() => {
      let model = localModel.value.map(slot => Object.assign({}, slot))
      model.forEach((slot, index) => {
        slot.slotTitle = {slot: index, title: slot.title}
        slot.buttonSlot = index + '.button'
        slot.contentSlot = index
      })
      return model
    })

    function onSave() {
      localModel.value.forEach((slot) => {
        if (slot.avatar && slot.avatar.file) {
          emit('avatarFileChanged', slot.avatar.file, slot)
          delete slot.avatar.file
        }
      })
      emit('input', localModel.value)
    }

    function onDiscard() {
      localModel.value = []
      props.value.forEach((slot) => {
        localModel.value.push({...slot, fields: slot.fields.map(field => Object.assign({}, field))})
      })
    }

    function onAvatarFileSelected(file, slot) {
      slot.avatar = {...slot.avatar, file: file, src: window.URL.createObjectURL(file)}
    }

    return {localModel, localModelComputed, onSave, onDiscard, onAvatarFileSelected}
  }
}
</script>

<style lang="scss">
/* Change label width at editor view */
#app .profile-component .v-editor-component.pr-1 .v-input::after {
  right: -32px;
}

#app .profile-component .v-editor-component .v-input__prepend-outer {
  flex: 0 0 140px;
  width: 140px;
}

#app .profile-component .v-editor-component .v-input.pr-1::after {
  right: -8px;
  width: 16px;
}
</style>
